<template>
    <v-autocomplete
        dense
        :label="label"
        :items="items"
        :loading="loading"
        :multiple="multiple"
        :disabled="disabled"
        :value="value"
        :search-input.sync="search"
        :item-text="studentLabel"
        item-value="id"
        outlined
        clearable
        cache-items
        hide-details="auto"
        :chips="multiple"
        :small-chips="multiple"
        :deletable-chips="multiple"
        no-data-text="Nenhum aluno encontrado"
        placeholder="Busque por nome, CPF ou matrícula"
        @input="onInput"
        @change="emitSelected"
    >
        <template #item="{ item }">
            <v-list-item-avatar>
                <v-img v-if="item.document_url" :src="item.document_url"></v-img>
                <v-icon v-else>mdi-account-school-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title>{{ item.name || "Aluno sem nome" }}</v-list-item-title>
                <v-list-item-subtitle>{{ studentSubtitle(item) }}</v-list-item-subtitle>
            </v-list-item-content>
        </template>
    </v-autocomplete>
</template>

<script>
import axios from "axios";
import debounce from "lodash/debounce";

export default {
    name: "StudentAutocomplete",

    props: {
        value: {
            type: [Array, Number, String],
            default: null,
        },
        selectedItems: {
            type: Array,
            default: () => [],
        },
        label: {
            type: String,
            default: "Aluno",
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        items: [],
        loading: false,
        search: "",
    }),

    watch: {
        selectedItems: {
            immediate: true,
            handler(items) {
                this.mergeItems(items || []);
            },
        },

        search(value) {
            this.searchStudents(value);
        },
    },

    methods: {
        mergeItems(items) {
            const byId = new Map(this.items.map((item) => [item.id, item]));

            items.filter(Boolean).forEach((item) => byId.set(item.id, item));

            this.items = Array.from(byId.values());
        },

        searchStudents: debounce(async function (term) {
            if (!term || term.length < 2) {
                this.items = [...this.selectedItems];
                return;
            }

            this.loading = true;

            try {
                const result = await axios.get("/api/v1/students", {
                    params: {
                        search: { term },
                        enrollment_status: "all",
                        limit: 20,
                    },
                });

                this.mergeItems(result.data.content.data || []);
            } finally {
                this.loading = false;
            }
        }, 350),

        onInput(value) {
            this.$emit("input", value);
            this.emitSelected(value);
        },

        emitSelected(value = this.value) {
            const selectedIds = this.multiple ? value || [] : [value].filter(Boolean);
            const selectedItems = selectedIds
                .map((id) => this.items.find((item) => Number(item.id) === Number(id)))
                .filter(Boolean);

            this.$emit("selected", this.multiple ? selectedItems : selectedItems[0] || null);
        },

        studentLabel(student) {
            if (!student) return "";

            const registration = student.registration ? ` - ${student.registration}` : "";
            const currentClass = student.enrollment && student.enrollment.class ? ` (${student.enrollment.class.name})` : "";

            return `${student.name || "Aluno sem nome"}${registration}${currentClass}`;
        },

        studentSubtitle(student) {
            const parts = [];

            if (student.registration) parts.push(`Matrícula/CPF: ${student.registration}`);
            if (student.enrollment && student.enrollment.class) parts.push(`Turma: ${student.enrollment.class.name}`);

            return parts.join(" · ") || "Sem matrícula ativa";
        },
    },
};
</script>
